export interface IQualification {
  id: number;
  code: string;
  name: string;
  type: string;
  // status:string;
  isActive: boolean;
  isOther: boolean;
  createdAt: string;
  updatedAt: string;
}
